// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-app-comparison-app-comparison-page-js": () => import("./../src/components/appComparison/AppComparisonPage.js" /* webpackChunkName: "component---src-components-app-comparison-app-comparison-page-js" */),
  "component---src-components-index-js": () => import("./../src/components/index.js" /* webpackChunkName: "component---src-components-index-js" */)
}

